export const firebaseConfig = {
  apiKey: "AIzaSyA2f9ZiWEYyj-rRgSuWKze08Pisl4c1oNY",
  authDomain: "ecobazar-236f5.firebaseapp.com",
  projectId: "ecobazar-236f5",
  storageBucket: "ecobazar-236f5.firebasestorage.app",
  messagingSenderId: "307590685752",
  appId: "1:307590685752:web:ba8c5c30e10f67ea2572cd",
  measurementId: "G-ZCTKNH24M7",
};
